// extracted by mini-css-extract-plugin
export default {"input":"rectangle_input_input__q5ZAb","icon":"rectangle_input_icon__8qL+q"};